import {
  useCallback,
  useEffect,
  useState,
} from 'react';

import { useNavigate } from 'react-router-dom';

import { login } from '../../services/Login/auth.service';
import {
  getRole,
  getToken,
  saveEmployeeLogin,
} from '../../utils/Login/authStorage';

import { useLoaderContext } from '../../../../components/Loader/LoaderContext';

export const useLogin = () => {
  const navigate = useNavigate();
const { showLoader, hideLoader } = useLoaderContext();

  const [employeeCode, setEmployeeCode] =
    useState('');

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState('');

  useEffect(() => {
    const token = getToken();

    if (!token) {
      return;
    }

    const role = getRole();

    navigate(
      role === 'Manager'
        ? '/rm-dashboard'
        : '/employee-dashboard',
      {
        replace: true,
      }
    );
  }, [navigate]);

  const handleLogin = useCallback(
    async (
      e: React.FormEvent<HTMLFormElement>
    ) => {
      e.preventDefault();

      setError('');

      try {
        setLoading(true);

        const response =
          await login({
            employeeCode,
          });

        saveEmployeeLogin(response);
        // Show Loader
showLoader();
// Wait 2 seconds
setTimeout(() => {

        navigate(
          '/employee-dashboard',
          {
            replace: true,
          }
        );

          // Hide Loader
  hideLoader();

}, 2000);
      } catch (err) {
        console.error(err);

        setError(
          'Invalid Employee Code or Password'
        );
      } finally {
        setLoading(false);
      }
    },
    [employeeCode, navigate]
  );

  return {
    employeeCode,
    setEmployeeCode,

    loading,
    error,

    handleLogin,
  };
};

export default useLogin;